import { is, literal, pattern, string, union } from "superstruct";

export const DATE_MODEL = pattern(
  string(),
  /([0-9]([0-9]([0-9][1-9]|[1-9]0)|[1-9]00)|[1-9]000)(-(0[1-9]|1[0-2])(-(0[1-9]|[1-2][0-9]|3[0-1]))?)?/
);
export const DATE_VALIDATOR = (value: unknown) =>
  is(value, union([DATE_MODEL, literal("")])) ||
  "Verwacht datum formaat: dd/mm/jjjj.";
